<mat-dialog-content>
  <app-templates-list [isPopup]="true" [serviceEstimateType]="data.serviceEstimateType" (selectedTemplate)="closePopup($event)">
  </app-templates-list>
</mat-dialog-content>
